import { render, staticRenderFns } from "./MenuPermissaoItem.vue?vue&type=template&id=677191e8&"
import script from "./MenuPermissaoItem.vue?vue&type=script&lang=js&"
export * from "./MenuPermissaoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports